module.exports = __webpack_public_path__ + "img/ZYCZ.6edf9c6d.png";